// extracted by mini-css-extract-plugin
export default {"verticalRule":"DetailsMetricsRow_verticalRule__1dxue","tooltipWrapper":"DetailsMetricsRow_tooltipWrapper__wcAe6"};